import { isLowDescriptionQuality } from 'partner360/features/keyInitiatives/ui/keyInitiativesQuality/helpers/isLowDescriptionQuality'

import { DESCRIPTION_QUALITY_CONFIG } from './config'
import { BAND_THRESHOLDS, EDescriptionQualityBand, IDescriptionQualityResult } from './models'

export { getActionableDescriptionQualityReasons } from 'partner360/entities/keyInitiatives'

const getBandThreshold = (band: EDescriptionQualityBand): number =>
  BAND_THRESHOLDS.find((threshold) => threshold.band === band)?.min ?? 0

export const getDescriptionQualityBand = (score: number): EDescriptionQualityBand =>
  BAND_THRESHOLDS.find((threshold) => score >= threshold.min)?.band ??
  EDescriptionQualityBand.Insufficient

// Use the same criterion as the "Show low-described initiatives" list, not the score colour band.
export const isDescriptionQualityBlocking = (quality?: IDescriptionQualityResult | null): boolean =>
  isLowDescriptionQuality(quality?.score ?? null, quality?.reasons ?? [])

export const isDescriptionQualityWarning = (quality?: IDescriptionQualityResult | null): boolean =>
  Boolean(
    quality &&
      quality.score >= getBandThreshold(EDescriptionQualityBand.Weak) &&
      quality.score < getBandThreshold(EDescriptionQualityBand.Good)
  )

export const getEmptyDescriptionQualityResult = (
  description?: string | null
): IDescriptionQualityResult | null =>
  description?.trim()
    ? null
    : {
        score: DESCRIPTION_QUALITY_CONFIG.defaultValue.score,
        reasons: [...DESCRIPTION_QUALITY_CONFIG.defaultValue.reasons],
      }
